module.exports = __webpack_public_path__ + "img/korektif-black.25eefe3e.svg";